import { styled } from '@mui/system';

type Container = { fixed?: boolean };

export const Container = styled('section')<Container>`
  position: ${props => props.fixed ? 'absolute' : 'block' };
  padding: ${props => props.fixed ? '16px 24px' : '8px 0 0' };
  bottom: 0;
  left: 0;
  z-index: 1;
`;